import script from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"

import "./FocusedLayout.vue?vue&type=style&index=0&id=42b95f65&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b95f65"]])

export default __exports__